import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class VersionService {
  // Don't use GenericHttpService here to avoid circular dependency when loading custom translations
  private readonly httpClient = inject(HttpClient);
  public osirisVersion = "?";

  setOsirisVersion(): Observable<string> {
    return this.httpClient.get<{ version: string }>("assets/osiris_version.json").pipe(
      catchError((error: HttpErrorResponse): Observable<{ version: string }> => {
        if (error.message.includes("localhost")) {
          return of({ version: "localhost" });
        }
        console.error("Error reading the file assets/osiris_version.json:", error);
        return of({ version: "unknown" });
      }),
      map((data) => data.version),
      tap((version) => {
        this.osirisVersion = version;
      }),
    );
  }
}
